import { useQuery } from "@tanstack/react-query"
import { getIframeChatConfigQuery } from "modules/campaigns/lib/templates/widget/getIframeChatConfigQuery"

export function useGetIframeChatConfigQuery(...args: Parameters<typeof getIframeChatConfigQuery>) {
  return useQuery(getIframeChatConfigQuery(...args))
}
